export default __webpack_public_path__ + "static/media/Shot_20.0000.daad1ddd.png";